export const POS_USER_INFO = 'POS.USERINFO';

export type PosUserInfoMessage = {
  message: string;
  userType: string;
  userName: string;
  navData: [];
  userEmail?: string;
};

export const createUserInfoMessage = (
  userType: string,
  userName: string,
  navData: [],
  userEmail?: string
): PosUserInfoMessage => {
  return {
    message: POS_USER_INFO,
    userType: userType,
    userName: userName,
    navData: navData,
    userEmail: userEmail,
  };
};
